"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var g2_1 = require("@antv/g2");
var column_label_1 = require("../../../column/component/label/column-label");
var StackColumnLabels = /** @class */ (function (_super) {
    tslib_1.__extends(StackColumnLabels, _super);
    function StackColumnLabels() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackColumnLabels.prototype.adjustPosition = function (label, shape) {
        var labelRange = label.getBBox();
        var shapeRange = shape.getBBox();
        if (shapeRange.height <= labelRange.height) {
            label.attr('opacity', 0);
            label.attr('fillOpacity', 0);
            label.attr('strokeOpacity', 0);
            label.set('capture', false);
        }
    };
    return StackColumnLabels;
}(column_label_1.ColumnLabels));
g2_1.registerElementLabels('stackColumnLabel', StackColumnLabels);
//# sourceMappingURL=stack-column-label.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/stack-column/component/label/stack-column-label.js
// module id = 981
// module chunks = 37